import { useMarkAsReadMutation } from '@/store/query/notification';
import { Button } from '@chakra-ui/react';

export const ReviewCandidateButton = ({
  interviewUrl,
  notification,
  ...props
}) => {
  const [markAsRead] = useMarkAsReadMutation();
  const handleReviewCandidate = () => {
    markAsRead({ id: notification?.id });
    window.open(interviewUrl, '_self');
  };

  return (
    <Button
      variant="tertiary"
      flex="1"
      onClick={handleReviewCandidate}
      {...props}
    >
      Review candidate
    </Button>
  );
};
